import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Hispanos de 55 años o más viviendo en Estados Unidos.', 'Personas que sienten fatiga crónica o falta de ánimo durante el día.', 'Aquellos preocupados por sus niveles de azúcar o presión arterial.', 'Padres y abuelos que quieren energía para jugar con sus nietos y disfrutar la vida.'];
  const notForWho = ["Personas que buscan una 'pastilla mágica' sin cambiar ningún hábito.", 'Quienes no están dispuestos a seguir un orden sencillo en sus comidas.', 'Menores de 40 años que aún no experimentan cambios en su ritmo metabólico.'];
  return <section className="py-20 bg-white" data-id="element-235">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10" data-id="element-237">
          {/* For Who */}
          <div className="bg-green-50 rounded-3xl p-8 md:p-10 border border-green-100" data-id="element-238">
            <h3 className="text-2xl font-bold text-green-900 mb-8 flex items-center gap-3" data-id="element-239">
              <span className="bg-green-200 text-green-800 p-2 rounded-full" data-id="element-240">
                <Check className="w-6 h-6" data-id="element-241" />
              </span>
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-242">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-243">
                  <Check className="w-6 h-6 text-green-600 shrink-0 mt-0.5" data-id="element-244" />
                  <span className="text-gray-800 text-lg leading-relaxed" data-id="element-245">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For Who */}
          <div className="bg-red-50 rounded-3xl p-8 md:p-10 border border-red-100" data-id="element-246">
            <h3 className="text-2xl font-bold text-red-900 mb-8 flex items-center gap-3" data-id="element-247">
              <span className="bg-red-200 text-red-800 p-2 rounded-full" data-id="element-248">
                <X className="w-6 h-6" data-id="element-249" />
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-250">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-251">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-252" />
                  <span className="text-gray-800 text-lg leading-relaxed" data-id="element-253">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}